export const createApplication = `
    mutation createApplication($input: CreateApplicationInput!) {
        createApplication(input:$input) {
            id
            name
            description
            url
            logoUrl
    }
}`;

export const updateApplication = `
    mutation updateApplication($input: UpdateApplicationInput!) {
        updateApplication(input:$input){
            id
            name
            description
            url
            logoUrl
        }
}`;

export const deleteApplication = `
    mutation deleteApplication($input: DeleteApplicationInput!) {
        deleteApplication(input:$input) {
            id
        }
        
}`;
